import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-bold text-textPrimary text-left w-full" }, "Selecionar escala", -1)
const _hoisted_2 = { class: "flex flex-col gap-4" }
const _hoisted_3 = { class: "relative" }
const _hoisted_4 = {
  key: 0,
  class: "flex justify-center py-8",
  "data-testid": "import-config-loading"
}
const _hoisted_5 = {
  key: 1,
  class: "flex flex-col items-center gap-3 py-6"
}
const _hoisted_6 = {
  class: "text-sm text-error text-center",
  "data-testid": "import-config-error"
}
const _hoisted_7 = {
  key: 2,
  class: "text-sm text-gray-500 text-center py-6",
  "data-testid": "import-config-empty"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "flex-1" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "block text-xs font-bold text-black text-left",
  style: {"letter-spacing":"0.06px"}
}, "Empresa", -1)
const _hoisted_11 = {
  class: "text-base font-normal text-black leading-6 text-left",
  style: {"letter-spacing":"0.08px"}
}
const _hoisted_12 = {
  key: 0,
  class: "flex flex-col gap-3 mt-3"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "flex-1" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", {
  class: "block text-xs font-bold text-black text-left",
  style: {"letter-spacing":"0.06px"}
}, "Unidade", -1)
const _hoisted_16 = {
  class: "text-base font-normal text-black leading-6 text-left",
  style: {"letter-spacing":"0.08px"}
}
const _hoisted_17 = {
  key: 0,
  class: "flex flex-col gap-2 mt-3"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 0,
  class: "w-2.5 h-2.5 rounded-full bg-primary"
}
const _hoisted_20 = { class: "flex-1" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", {
  class: "block text-xs font-bold text-black text-left",
  style: {"letter-spacing":"0.06px"}
}, "Escala", -1)
const _hoisted_22 = {
  class: "text-base font-normal text-black leading-6 text-left",
  style: {"letter-spacing":"0.08px"}
}
const _hoisted_23 = {
  key: 0,
  class: "flex justify-center py-2",
  "data-testid": "import-config-unit-loading"
}
const _hoisted_24 = {
  key: 1,
  class: "flex flex-col items-center gap-2 py-2",
  "data-testid": "import-config-unit-error"
}
const _hoisted_25 = { class: "text-xs text-error text-center" }
const _hoisted_26 = {
  key: 2,
  class: "text-xs text-gray-500 text-center py-2",
  "data-testid": "import-config-unit-empty"
}
const _hoisted_27 = ["data-load-more"]
const _hoisted_28 = {
  key: 0,
  "data-load-more": "search",
  class: "flex justify-center py-3",
  "data-testid": "import-config-load-more-sentinel"
}
const _hoisted_29 = { class: "flex justify-between gap-4" }

import { ref, computed, watch, nextTick, onBeforeUnmount } from 'vue'

import { mdiMagnify, mdiMenuDown } from '@mdi/js'

import Network from '@/Network'
import type {
  ImportableScheduleItem,
  ImportableScheduleTreeCompany
} from '@/Network/Types/Responses/ScheduleUnitResponses'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import OutlinedButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import SVGIcon from '@/components/SVGIcon.vue'
import { groupImportableSchedules } from '@/utils/schedule'
import { getApiErrorMessage } from '@/utils/apiError'

const PAGE_SIZE = 20
const SEARCH_DEBOUNCE_MS = 300

type UnitPage = {
  items: { id: number; name: string }[]
  count: number
  isLoading: boolean
  error: string
}

/** Nó de unidade já resolvido para renderização, em qualquer um dos dois modos. */
type RenderUnit = {
  id: number
  name: string
  schedules: { id: number; name: string }[]
  isLoading: boolean
  error: string
  hasMore: boolean
}

type RenderCompany = { id: number; name: string; units: RenderUnit[] }

// Modo navegação: estrutura completa numa chamada + escalas paginadas por unidade.

export default /*#__PURE__*/_defineComponent({
  __name: 'ImportScheduleConfigModal',
  props: {
    modalActive: { type: Boolean },
    isImporting: { type: Boolean },
    confirmText: {}
  },
  emits: ["close", "select"],
  setup(__props: any, { emit }) {

const props = __props;




/** Página de escalas de uma unidade, no modo de navegação. */
const treeCompanies = ref<ImportableScheduleTreeCompany[]>([])
const unitPages = ref<Map<number, UnitPage>>(new Map())

// Modo busca: lista plana global, agrupada para render, com sentinela única.
const searchItems = ref<ImportableScheduleItem[]>([])
const searchCount = ref(0)
const isLoadingMoreSearch = ref(false)

const isLoading = ref(false)
const errorMessage = ref('')
const searchQuery = ref('')
const selectedScheduleId = ref<number | null>(null)
const expandedCompanies = ref<Set<number>>(new Set())
const expandedUnits = ref<Set<number>>(new Set())

const scrollContainer = ref<HTMLElement | null>(null)
let observer: IntersectionObserver | null = null
let searchDebounceTimer: ReturnType<typeof setTimeout> | undefined

const isSearching = computed(() => searchQuery.value.trim().length > 0)
const hasMoreSearch = computed(() => searchItems.value.length < searchCount.value)

/**
 * Os dois modos são normalizados na mesma forma de render, então o template não sabe
 * de qual endpoint os dados vieram.
 *
 * - navegação: `treeCompanies` (estrutura) + `unitPages` (escalas por unidade);
 * - busca: resultado plano agrupado, sem paginação por unidade — a sentinela é única.
 */
const tree = computed<RenderCompany[]>(() => {
  if (isSearching.value) {
    return groupImportableSchedules(searchItems.value).map((company) => ({
      id: company.id,
      name: company.name,
      units: company.units.map((unit) => ({
        id: unit.id,
        name: unit.name,
        schedules: unit.schedules,
        isLoading: false,
        error: '',
        hasMore: false
      }))
    }))
  }

  return treeCompanies.value.map((company) => ({
    id: company.id,
    name: company.name,
    units: company.units.map((unit) => {
      const page = unitPages.value.get(unit.id)
      return {
        id: unit.id,
        name: unit.name,
        schedules: page?.items ?? [],
        isLoading: page?.isLoading ?? false,
        error: page?.error ?? '',
        hasMore: page ? page.items.length < page.count : false
      }
    })
  }))
})

function toggleExpanded(level: 'company' | 'unit', id: number) {
  const set = level === 'company' ? expandedCompanies : expandedUnits
  if (set.value.has(id)) {
    set.value.delete(id)
  } else {
    set.value.add(id)
    // No modo navegação as escalas só são buscadas quando a unidade abre.
    if (level === 'unit' && !isSearching.value && !unitPages.value.has(id)) {
      loadUnitSchedules(id, { append: false })
    }
  }
}

function isExpanded(level: 'company' | 'unit', id: number): boolean {
  const set = level === 'company' ? expandedCompanies : expandedUnits
  return set.value.has(id)
}

/**
 * Com a busca no servidor, deixar a árvore colapsada esconderia o resultado atrás
 * dos chevrons. Enquanto há termo de busca, tudo que voltou fica aberto.
 */
function expandAllForSearch() {
  tree.value.forEach((company) => {
    expandedCompanies.value.add(company.id)
    company.units.forEach((unit) => expandedUnits.value.add(unit.id))
  })
}

// ---------------------------------------------------------------------------
// Modo navegação
// ---------------------------------------------------------------------------

async function loadTree() {
  isLoading.value = true
  errorMessage.value = ''
  try {
    treeCompanies.value = await Network.schedule.listImportableTree()
  } catch (e) {
    // `e instanceof Error ? e.message : ...` vazava texto técnico de TypeError e
    // ignorava rede/timeout/5xx — o funil canônico cobre os três casos.
    errorMessage.value = getApiErrorMessage(e, 'Não foi possível carregar as escalas disponíveis.')
    treeCompanies.value = []
  } finally {
    isLoading.value = false
  }
  await refreshObserver()
}

async function loadUnitSchedules(healthUnitId: number, { append }: { append: boolean }) {
  const current = unitPages.value.get(healthUnitId)
  if (current?.isLoading) return

  const page: UnitPage = {
    items: append ? (current?.items ?? []) : [],
    count: append ? (current?.count ?? 0) : 0,
    isLoading: true,
    error: ''
  }
  unitPages.value.set(healthUnitId, page)
  // Map não é reativo por mutação: reatribuir é o que dispara o re-render.
  unitPages.value = new Map(unitPages.value)

  try {
    const response = await Network.schedule.listImportableConfigurations({
      healthUnitId,
      offset: page.items.length,
      limit: PAGE_SIZE
    })

    unitPages.value.set(healthUnitId, {
      items: [...page.items, ...response.data.map(({ id, name }) => ({ id, name }))],
      count: response.count,
      isLoading: false,
      error: ''
    })
  } catch (e) {
    unitPages.value.set(healthUnitId, {
      ...page,
      isLoading: false,
      error: getApiErrorMessage(e, 'Não foi possível carregar as escalas desta unidade.')
    })
  } finally {
    unitPages.value = new Map(unitPages.value)
    await refreshObserver()
  }
}

// ---------------------------------------------------------------------------
// Modo busca
// ---------------------------------------------------------------------------

async function fetchSearchPage({ append }: { append: boolean }) {
  if (append) {
    isLoadingMoreSearch.value = true
  } else {
    isLoading.value = true
  }
  errorMessage.value = ''

  const requestedQuery = searchQuery.value.trim()

  try {
    const response = await Network.schedule.listImportableConfigurations({
      q: requestedQuery,
      offset: append ? searchItems.value.length : 0,
      limit: PAGE_SIZE
    })

    // Descarta resposta obsoleta: o usuário pode ter digitado outra coisa enquanto
    // esta requisição estava em voo, e concatenar aqui misturaria dois resultados.
    if (requestedQuery !== searchQuery.value.trim()) return

    searchItems.value = append ? [...searchItems.value, ...response.data] : response.data
    searchCount.value = response.count
    expandAllForSearch()
  } catch (e) {
    errorMessage.value = getApiErrorMessage(e, 'Não foi possível carregar as escalas disponíveis.')
    if (!append) {
      searchItems.value = []
      searchCount.value = 0
    }
  } finally {
    isLoading.value = false
    isLoadingMoreSearch.value = false
    await refreshObserver()
  }
}

/** Recarrega o modo atual a partir do zero. */
async function reload() {
  if (isSearching.value) {
    searchItems.value = []
    searchCount.value = 0
    await fetchSearchPage({ append: false })
    return
  }
  unitPages.value = new Map()
  await loadTree()
}

// ---------------------------------------------------------------------------
// Scroll infinito
// ---------------------------------------------------------------------------

/**
 * Um único observer para todas as sentinelas: a do resultado de busca e uma por
 * unidade expandida que ainda tem página. O alvo carrega a unidade no próprio
 * atributo, então o callback não precisa de closure por unidade.
 *
 * `disconnect()` + `observe()` a cada carga é intencional: o IntersectionObserver
 * só notifica em MUDANÇA de interseção, então uma sentinela que continua visível
 * depois de uma página nunca reemitiria e a paginação travaria até o usuário rolar.
 * Reobservar força uma notificação inicial nova.
 */
async function refreshObserver() {
  disconnectObserver()
  await nextTick()

  const container = scrollContainer.value
  if (!container || typeof IntersectionObserver === 'undefined') return

  const sentinels = container.querySelectorAll<HTMLElement>('[data-load-more]')
  if (!sentinels.length) return

  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return
        const target = entry.target as HTMLElement
        const unitId = target.dataset.loadMore

        if (unitId === 'search') {
          if (isLoading.value || isLoadingMoreSearch.value || !hasMoreSearch.value) return
          fetchSearchPage({ append: true })
          return
        }

        const healthUnitId = Number(unitId)
        const page = unitPages.value.get(healthUnitId)
        if (!page || page.isLoading || page.items.length >= page.count) return
        loadUnitSchedules(healthUnitId, { append: true })
      })
    },
    { root: container, rootMargin: '80px' }
  )
  sentinels.forEach((sentinel) => observer?.observe(sentinel))
}

function disconnectObserver() {
  observer?.disconnect()
  observer = null
}

// Abrir/fechar unidade cria e destrói sentinelas, então o observer precisa ser
// reapontado quando o conjunto de expandidos muda.
watch([expandedCompanies, expandedUnits], () => refreshObserver(), { deep: true })

watch(searchQuery, () => {
  if (!props.modalActive) return
  clearTimeout(searchDebounceTimer)
  searchDebounceTimer = setTimeout(() => {
    // `resetState()` limpa o campo de busca, o que reagenda este timer enquanto o
    // modal ainda está marcado como aberto. A segunda checagem evita a requisição
    // fantasma que dispararia depois de fechar ou de importar.
    if (!props.modalActive) return
    selectedScheduleId.value = null
    expandedCompanies.value = new Set()
    expandedUnits.value = new Set()
    reload()
  }, SEARCH_DEBOUNCE_MS)
})

watch(
  () => props.modalActive,
  (active) => {
    if (!active) {
      // Cobre também o fechamento vindo do pai (import concluído), em que
      // `handleClose` não é chamado — sem isso a seleção e a busca sobreviveriam
      // para a próxima abertura.
      resetState()
      return
    }
    reload()
  },
  // `immediate` cobre o caso de o componente ser montado já com o modal aberto.
  // Sem isso, o watcher só reagiria à transição fechado → aberto e a lista ficaria
  // permanentemente vazia.
  { immediate: true }
)

function resetState() {
  clearTimeout(searchDebounceTimer)
  disconnectObserver()
  selectedScheduleId.value = null
  searchQuery.value = ''
  errorMessage.value = ''
  treeCompanies.value = []
  unitPages.value = new Map()
  searchItems.value = []
  searchCount.value = 0
  expandedCompanies.value = new Set()
  expandedUnits.value = new Set()
}

function handleClose() {
  if (props.isImporting) return
  resetState()
  emit('close')
}

/**
 * Não reseta o estado aqui: o import é assíncrono e o modal fica aberto até o pai
 * concluir. Zerar a seleção agora apagaria da tela a escala escolhida durante o
 * loading e, em caso de falha, deixaria o modal aberto sem nada selecionado.
 * A limpeza acontece quando o pai fecha o modal (watcher de `modalActive`).
 */
function handleImport() {
  if (props.isImporting) return
  const scheduleId = selectedScheduleId.value
  if (scheduleId === null) return
  const company = tree.value.find((item) =>
    item.units.some((unit) => unit.schedules.some((schedule) => schedule.id === scheduleId))
  )
  emit('select', scheduleId, company?.id ?? null)
}

onBeforeUnmount(() => {
  clearTimeout(searchDebounceTimer)
  disconnectObserver()
})

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createBlock(ModalVue, {
    modalActive: _ctx.modalActive,
    hasHeaderBorder: true,
    hasFooterBorder: true,
    maxWidth: "max-w-[640px]",
    onClose: handleClose
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_29, [
        _createVNode(OutlinedButton, {
          text: "Cancelar",
          width: "auto",
          height: "44px",
          disabled: _ctx.isImporting,
          "data-testid": "import-config-cancel-button",
          onClick: handleClose
        }, null, 8, ["disabled"]),
        _createVNode(FilledButton, {
          text: _ctx.confirmText ?? 'Importar configurações',
          width: "auto",
          height: "44px",
          loading: _ctx.isImporting,
          disabled: selectedScheduleId.value === null || _ctx.isImporting,
          class: "bg-primary30",
          "data-testid": "import-config-confirm-button",
          onClick: handleImport
        }, null, 8, ["text", "loading", "disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(SVGIcon, {
            path: _unref(mdiMagnify),
            class: "absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400"
          }, null, 8, ["path"]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
            type: "text",
            placeholder: "Buscar empresa, unidade ou escala",
            maxlength: "120",
            class: "w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary30 focus:border-primary30",
            "data-testid": "import-config-search-input"
          }, null, 512), [
            [_vModelText, searchQuery.value]
          ])
        ]),
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_v_progress_circular, {
                indeterminate: "",
                color: "primary",
                size: "32"
              })
            ]))
          : (errorMessage.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("p", _hoisted_6, _toDisplayString(errorMessage.value), 1),
                _createVNode(OutlinedButton, {
                  text: "Tentar novamente",
                  width: "auto",
                  height: "36px",
                  "data-testid": "import-config-retry-button",
                  onClick: reload
                })
              ]))
            : (tree.value.length === 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, " Nenhuma escala encontrada "))
              : (_openBlock(), _createElementBlock("div", {
                  key: 3,
                  ref_key: "scrollContainer",
                  ref: scrollContainer,
                  class: "flex flex-col gap-3 max-h-[400px] overflow-y-auto"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tree.value, (company) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: company.id,
                      class: "rounded-lg bg-[#F0F0F4] p-3"
                    }, [
                      _createElementVNode("div", {
                        class: "flex items-center justify-between cursor-pointer hover:opacity-80 transition-opacity",
                        "data-testid": "import-config-company-row",
                        onClick: ($event: any) => (toggleExpanded('company', company.id))
                      }, [
                        _createElementVNode("div", _hoisted_9, [
                          _hoisted_10,
                          _createElementVNode("p", _hoisted_11, _toDisplayString(company.name), 1)
                        ]),
                        _createVNode(SVGIcon, {
                          path: _unref(mdiMenuDown),
                          class: "w-6 h-6 text-gray-400 shrink-0"
                        }, null, 8, ["path"])
                      ], 8, _hoisted_8),
                      (isExpanded('company', company.id))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(company.units, (unit) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: unit.id,
                                class: "rounded-lg bg-white p-3"
                              }, [
                                _createElementVNode("div", {
                                  class: "flex items-center justify-between cursor-pointer hover:opacity-80 transition-opacity",
                                  "data-testid": "import-config-unit-row",
                                  onClick: ($event: any) => (toggleExpanded('unit', unit.id))
                                }, [
                                  _createElementVNode("div", _hoisted_14, [
                                    _hoisted_15,
                                    _createElementVNode("p", _hoisted_16, _toDisplayString(unit.name), 1)
                                  ]),
                                  _createVNode(SVGIcon, {
                                    path: _unref(mdiMenuDown),
                                    class: "w-6 h-6 text-gray-400 shrink-0"
                                  }, null, 8, ["path"])
                                ], 8, _hoisted_13),
                                (isExpanded('unit', unit.id))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(unit.schedules, (schedule) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: schedule.id,
                                          class: _normalizeClass(["flex items-start gap-3 p-2 rounded-lg border cursor-pointer transition-colors", 
                    selectedScheduleId.value === schedule.id
                      ? 'bg-primary5 border-primary'
                      : 'bg-[#F0F0F4] border-gray-200 hover:bg-gray-200'
                  ]),
                                          "data-testid": "import-config-schedule-option",
                                          onClick: ($event: any) => (selectedScheduleId.value = schedule.id)
                                        }, [
                                          _createElementVNode("div", {
                                            class: _normalizeClass(["w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 mt-0.5", 
                      selectedScheduleId.value === schedule.id ? 'border-primary' : 'border-gray-300'
                    ])
                                          }, [
                                            (selectedScheduleId.value === schedule.id)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_19))
                                              : _createCommentVNode("", true)
                                          ], 2),
                                          _createElementVNode("div", _hoisted_20, [
                                            _hoisted_21,
                                            _createElementVNode("p", _hoisted_22, _toDisplayString(schedule.name), 1)
                                          ])
                                        ], 10, _hoisted_18))
                                      }), 128)),
                                      (unit.isLoading && unit.schedules.length === 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                            _createVNode(_component_v_progress_circular, {
                                              indeterminate: "",
                                              color: "primary",
                                              size: "20"
                                            })
                                          ]))
                                        : (unit.error)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                              _createElementVNode("p", _hoisted_25, _toDisplayString(unit.error), 1),
                                              _createVNode(OutlinedButton, {
                                                text: "Tentar novamente",
                                                width: "auto",
                                                height: "32px",
                                                "data-testid": "import-config-unit-retry-button",
                                                onClick: ($event: any) => (loadUnitSchedules(unit.id, { append: false }))
                                              }, null, 8, ["onClick"])
                                            ]))
                                          : (unit.schedules.length === 0)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_26, " Nenhuma escala nesta unidade "))
                                            : _createCommentVNode("", true),
                                      (unit.hasMore)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 3,
                                            "data-load-more": unit.id,
                                            class: "flex justify-center py-2",
                                            "data-testid": "import-config-unit-load-more-sentinel"
                                          }, [
                                            (unit.isLoading)
                                              ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                                  key: 0,
                                                  indeterminate: "",
                                                  color: "primary",
                                                  size: "20",
                                                  "data-testid": "import-config-unit-loading-more"
                                                }))
                                              : _createCommentVNode("", true)
                                          ], 8, _hoisted_27))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128)),
                  (hasMoreSearch.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        (isLoadingMoreSearch.value)
                          ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                              key: 0,
                              indeterminate: "",
                              color: "primary",
                              size: "20",
                              "data-testid": "import-config-loading-more"
                            }))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ], 512))
      ])
    ]),
    _: 1
  }, 8, ["modalActive"]))
}
}

})